// extracted by mini-css-extract-plugin
export var black = "_2w-6";
export var brand = "_2w-1";
export var ddefault = "_2w-0";
export var error = "_2w-3";
export var gray = "_2w-2";
export var highContrast = "_2w-8";
export var outline = "_2w-7";
export var success = "_2w-5";
export var warning = "_2w-4";